// extracted by mini-css-extract-plugin
module.exports = {"plan":"Contact_plan__2mhfB","iframe":"Contact_iframe__1SprG","text_contact":"Contact_text_contact__10aQt"};